import "../1config";
import "./auth0_auth";
import sentry_loader from "./sentry_io"

export default () => {
    sentry_loader()
};
